import React from 'react';
import image from "../../assets/img/page/who-we-are.jpg";
import Count from '../common/count';

const ChairmanMessage = () => {
    return (
        <>
        <div className="chairman-message section-padding" style={{
            background: 'linear-gradient(135deg, #f8fafc 60%, #e3e9f7 100%)',
            borderRadius: '24px',
            boxShadow: '0 8px 32px rgba(60,60,120,0.12)',
            margin: '40px 0',
            border: '2px solid #e0e7ef'
        }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="chairman-message__content" style={{
                            padding: '40px 30px',
                            background: '#fff',
                            borderRadius: '18px',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
                            borderLeft: '6px solid #ffbf43',
                            position: 'relative',
                            color: '#333',
                        }}>
                            <h3 className="mb-20" style={{color: '#333', fontWeight: 700, letterSpacing: '1px'}}>Chairman’s Message</h3>
                            <p className="mb-20" style={{fontWeight: 600, color: '#222'}}>Dear Valued Clients, Partners, and Stakeholders,</p>
                            <p className="mb-20">
                                With immense pride and enthusiasm, I warmly welcome you to this initiative. As the Chairman of our esteemed company, I am honored to share our journey, vision, and commitment to excellence.
                            </p>
                            <p className="mb-20">
                                Our company was established with a steadfast mission: to provide unparalleled expertise in construction, supervision, consultancy, design, drawing, feasibility studies, material supply including IT and software development. Over the years, we have expanded our capabilities to include export, import, and marketing, ensuring that we cater to a diverse range of industries and client needs.
                            </p>
                            <p className="mb-20">
                                We take immense pride in being more than just a service provider; we are partners in progress, dedicated to shaping a sustainable and innovative future. With a strong foundation built on integrity, quality, and customer satisfaction, we continue to strive for excellence in every project we undertake.
                            </p>
                            <p className="mb-20">
                                Looking ahead, we are committed in adopting the latest technologies, implementing sustainable solutions, and adhering to global best practices to deliver superior results. Our goal is to set new industry benchmarks and redefine standards of quality and reliability.
                            </p>
                            <p className="mb-20">
                                I would like to express my sincere appreciation to our dedicated employees, esteemed clients, and trusted partners for their unwavering support. Your confidence in us fuels our determination to achieve new milestones and create lasting value.
                            </p>
                            <p className="mb-20">
                                Thank you for being a part of our journey. We look forward in collaborating and building a prosperous future together.
                            </p>
                            <p className="mb-20" style={{fontWeight: 800, color: '#333'}}>
                                Warm regards<br/>
                                Dr. Brigadier General (Retd) Md. Abul Kalam Azad, ndc, psc, FIEB
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ChairmanMessage;